function formatarData(data) {
  let dia = String(data.getDate()).padStart(2, '0')
  let mes = String(data.getMonth() + 1).padStart(2, '0') // Os meses são indexados a partir de 0, por isso é adicionado +1
  let ano = data.getFullYear()

  return dia + '/' + mes + '/' + ano
}

const dataAtual = new Date()
const dataMesAnterior = new Date(
  dataAtual.getFullYear(),
  dataAtual.getMonth(),
  dataAtual.getDate() - 151
)

const dataAtualFormatada = formatarData(dataAtual)
const dataMesAnteriorFormatada = formatarData(dataMesAnterior)

export const infoHtml = ``
